var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCoupon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00488 5.38867H19.0049C19.2195 5.38867 19.3943 5.56276 19.3945 5.77734V9.70117C18.291 9.88634 17.4502 10.8439 17.4502 12C17.4502 13.1561 18.2911 14.1126 19.3945 14.2979V18.2227C19.3943 18.4372 19.2195 18.6113 19.0049 18.6113H5.00488C4.79045 18.6111 4.61645 18.4371 4.61621 18.2227V14.2979C5.71961 14.1126 6.56055 13.156 6.56055 12C6.56055 10.8439 5.71969 9.88638 4.61621 9.70117V5.77734C4.61644 5.56291 4.79045 5.38891 5.00488 5.38867ZM13.9502 13.167V13.9443H10.0605V13.167H13.9502ZM13.9502 10.0557V10.833H10.0605V10.0557H13.9502ZM18.6162 14.8955L18.4004 14.7881C17.3751 14.2786 16.6719 13.2209 16.6719 12C16.6719 10.7791 17.3751 9.72149 18.4004 9.21191L18.6162 9.10449V6.16699H5.39453V9.10449L5.61035 9.21191C6.63558 9.7215 7.33887 10.7791 7.33887 12C7.33887 13.2209 6.63558 14.2785 5.61035 14.7881L5.39453 14.8955V17.833H18.6162V14.8955Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.777777
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCoupon);
export default __webpack_public_path__ + "static/media/header-coupon.20c945209b45fa7687c4458203e6618d.svg";
export { ForwardRef as ReactComponent };